export default class WhatsNewModal extends HTMLElement {
  connectedCallback () {
    this.overlay = this.querySelector('[data-whats-new-modal-target="overlay"]')
    this.gotItBtn = this.querySelector('[data-whats-new-modal-target="gotItBtn"]')
    this.dontShowAgainCheckbox = this.querySelector('[data-whats-new-modal-target="dontShowAgainCheckbox"]')

    this.gotItBtn?.addEventListener('click', this.onGotIt)
    this.overlay?.addEventListener('click', this.onOverlayClick)
  }

  disconnectedCallback () {
    this.gotItBtn?.removeEventListener('click', this.onGotIt)
    this.overlay?.removeEventListener('click', this.onOverlayClick)
  }

  onGotIt = () => {
    this.dismissModal()
  }

  onOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      this.dismissModal()
    }
  }

  async dismissModal () {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''
    const suppressFuture = this.dontShowAgainCheckbox?.checked === true

    const requests = [
      // Always save dismissal timestamp
      fetch('/user_configs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          user_config: {
            key: 'whats_new_dismissed_at',
            value: new Date().toISOString()
          }
        })
      })
    ]

    // If "Don't show again" is checked, also set suppression flag
    if (suppressFuture) {
      requests.push(
        fetch('/user_configs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          },
          body: JSON.stringify({
            user_config: {
              key: 'whats_new_suppressed',
              value: true
            }
          })
        })
      )
    }

    try {
      await Promise.all(requests)
    } catch (err) {
      // Silently fail — the modal should still close even if the API call fails
      console.error('Failed to save whats new dismissal state:', err)
    }

    this.close()
  }

  close () {
    this.classList.add('hidden')
  }
}
